module.exports = __webpack_public_path__ + "static/media/plv.logo.160w.e58fad03.png";